<template>
    <el-dialog
        :visible.sync="dialogInvitVisible"
        width="520px"
        :before-close="handleInvitDialogClose"
        :close-on-click-modal="false"
        class="custom-dialog custom-invit-dialog"
    >
        <div class="invite-content" v-loading="loading">
            <div class="invite_head">
                <span :class="pageActive == 1 ? 'active' : ''" @click="handleClickTab(1)">新员工加入</span>
                <span :class="pageActive == 2 ? 'active' : ''" @click="handleClickTab(2)">添加企业成员</span>
            </div>
            <div class="invite_text" v-if="pageActive == 1">
                下载二维码，或复制链接可邀请新员工填写个人信息，填写完成后将自动新增人员，确认入职后账号生效！
            </div>
            <div class="invite_text" v-if="pageActive == 2">
                “企业成员”是你在企业、部门或组织内的同事，可批量邀请加入公司，加入公司后账号生效
            </div>
            <div class="qrcode_out_box" id="qrcodeOutBox" ref="qrcodeOutBox">
                <div class="invite-code-box">
                    <div class="invite-company-logo">
                        <img
                            :src="
                                company_log
                                    ? company_log
                                    : 'https://download.hecoos.com/enlightv/2024-50/6919ee7c360932f1a3d707340824fc36.png'
                            "
                            alt=""
                            class=""
                        />
                    </div>

                    <div id="qrcode" ref="qrcode"></div>
                    <div class="invite_link">
                        <template v-if="pageActive == 1">
                            邀请你加入【{{ company_name }}】，区号为 +86 的手机号可通过链接加入
                        </template>
                        <template v-else> 【{{ user_name }}】邀请你加入<br />澜精灵ERP开启协同办公 </template>
                    </div>
                    <div class="invite_time">
                        失效时间：<span v-if="formattedDate">{{ formattedDate }}</span>
                        <span class="invalid-txt" @click="handleClickDelete"
                            ><i class="iconfont icon-tingyong"></i>失效</span
                        >
                    </div>
                </div>
            </div>

            <div class="invite_btn">
                <el-button type="primary" plain @click="handleClickCopyUrl">复制链接</el-button>
                <el-button type="primary" @click="handleClickCopyImg">下载二维码</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";
import { mapState } from "vuex";
import { encryptAES } from "@/utils/index";
import { addInviteLink, deleteInviteLink } from "@/api/index.js";
export default {
    props: {
        dialogInvitVisible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            company_name: "",
            company_log: "",
            company_id: "",
            user_name: "",
            pageActive: 1,
            copyLink: "",
            formattedDate: "",
            QRCode: null,
            invite_id: "",
        };
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    created() {
        if (this.userInfo) {
            this.company_id = this.userInfo.user.company_id;
            this.company_name = this.userInfo.user.company_name;
            this.company_logo = this.userInfo.user.company_logo;
            this.user_name = this.userInfo.user.name;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.get_invite_link(1);
        });
    },
    methods: {
        handleInvitDialogClose() {
            this.$emit("update:dialogInvitVisible", false);
        },
        handleClickTab(tab) {
            this.pageActive = tab;
            this.get_invite_link(tab);
        },
        get_invite_link(tab) {
            let postData = {
                type: tab == 1 ? "person" : "enterprise",
            };
            this.loading = true;
            addInviteLink(postData)
                .then((res) => {
                    if (res.code === 200) {
                        let { invite_id, expiration_date } = res.data;
                        this.invite_id = invite_id;
                        this.formattedDate = expiration_date;
                        const domain = window.location.protocol + "//" + window.location.host;
                        this.copyLink = `${domain}/#/login/invit?type=${tab}&invite_id=${encryptAES(invite_id)}`;
                        this.setQrcode();
                    }
                    this.loading = false;
                })
                .catch(() => {});
        },
        setQrcode() {
            if (this.$refs.qrcode) {
                this.$refs.qrcode.innerHTML = "";
                setTimeout(() => {
                    this.QRCode = new QRCode(this.$refs.qrcode, {
                        width: 120,
                        height: 120,
                        render: "canvas",
                        fill: "#666666",
                        text: this.copyLink,
                        id: "canvasID",
                        correctLevel: 1,
                    });
                });
                this.$forceUpdate();
            }
        },
        handleClickDelete() {
            const h = this.$createElement;
            this.$msgbox({
                title: "确定要失效吗？",
                message: h("div", null, [h("span", null, "已分享的链接和二维码都将立即失效")]),
                iconClass: `icon-jinggao iconfont prompt_message_icon status0`,
                customClass: "prompt_message_custom",
                confirmButtonText: "确定",
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: true,
                showClose: false,
                confirmButtonClass: "el-button--danger danger",
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        done();
                    } else {
                        done();
                    }
                },
            })
                .then(() => {
                    this.loading = true;
                    deleteInviteLink({ invite_id: this.invite_id })
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success(res.message);
                                this.get_invite_link(this.pageActive);
                            }
                            this.loading = false;
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },
        handleClickCopyUrl() {
            let textToCopy = this.copyLink;
            if(this.pageActive == 1) {
                // 新员工加入
                textToCopy = `【${this.user_name}】邀请你加入【${this.company_name}】，请使用区号为 +86 的手机号通过此链接 ${this.copyLink} 加入`
            } else {
                // 添加企业成员
                textToCopy = `【${this.user_name}】邀请你加入澜精灵ERP开始协同办公，请使用区号为 +86 的手机号可通过此链接 ${this.copyLink} 加入`
            }
            const textarea = document.createElement("textarea");
            textarea.value = textToCopy;
            document.body.appendChild(textarea);
            // 选中文本并复制
            textarea.select();
            document.execCommand("copy");
            // 移除临时元素
            document.body.removeChild(textarea);
            this.$message.success("已成功复制！");
        },
        async handleClickCopyImg() {
            const canvas = await html2canvas(document.querySelector("#qrcodeOutBox"), {
                allowTaint: true,
                useCORS: true,
            });
            if (canvas) {
                const url = canvas.toDataURL("image/png").replace(/^data:image\/[^;]/, "data:application/octet-stream");
                var link = document.createElement("a");
                link.download = "邀请.png"; // 下载的文件名
                link.href = url;
                link.click();
            }
        },
    },
};
</script>
<style lang="scss">
.custom-invit-dialog {
    .el-dialog {
        height: auto;
    }

    .el-dialog__header {
        height: 0;
        padding: 0;
        border-bottom: none;
    }

    .el-dialog__body {
        padding: 30px 24px;
    }

    .invite_head {
        width: 320px;
        height: 38px;
        margin: 0 auto;
        border-radius: 6px;
        background: rgba(237, 240, 244, 1);
        box-shadow: inset 0px 1px 4px 1px rgba(25, 144, 255, 0.04);
        overflow: hidden;
        display: flex;

        span {
            display: block;
            flex: 1;
            height: 38px;
            text-align: center;
            line-height: 38px;
            background-color: rgba(237, 240, 244, 1);
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(102, 102, 102, 1);
            cursor: pointer;

            &:hover {
                background-color: rgba(25, 144, 255, 0.5);
                color: #fff;
            }

            &.active {
                background-color: rgba(25, 144, 255, 1);
                font-size: 14px;
                font-weight: 700;
                color: rgba(255, 255, 255, 1);
            }
        }
    }

    .invite_text {
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(153, 153, 153, 1);
        text-align: center;
        margin: 16px 0 30px;
    }
    .qrcode_out_box {
        padding: 22px 0 10px;
    }
    .invite-code-box {
        width: 300px;
        height: 306px;
        opacity: 1;
        border-radius: 12px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(232, 232, 232, 1);
        margin: 0 auto;
        text-align: center;
        padding: 52px 17px 0;
        position: relative;
        overflow: visible;

        .invite-company-logo {
            position: absolute;
            top: -22px;
            left: 128px;
            width: 44px;
            height: 44px;
            opacity: 1;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(255, 255, 255, 1);
            box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.08);
            border-radius: 50%;
            // overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                box-shadow: 0px 0px 4px  rgba(0, 0, 0, 0.08);
                object-fit: cover;
            }

            span {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                color: rgba(255, 255, 255, 0.8);
                text-align: center;
                line-height: 42px;
                font-size: 14px;
                font-weight: 700;
            }
        }

        #qrcode {
            width: 120px;
            height: 120px;
            margin: 0 auto;
            background-color: rgb(237, 240, 244);
        }

        .invite_link {
            margin: 24px 0 12px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);
        }

        .invite_time {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(102, 102, 102, 1);
        }

        .invalid-txt {
            margin-left: 4px;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(228, 65, 68, 1);
            padding: 0 4px;
            cursor: pointer;
            .iconfont {
                font-size: 14px;
                margin-right: 2px;
            }
        }
    }

    .invite_btn {
        margin-top: 26px;
        width: 100%;
        display: flex;
        gap: 16px;

        .el-button {
            flex: 1;
            & + .el-button {
                margin-left: 0;
            }
        }
    }
}
</style>
